import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit, TemplateRef } from '@angular/core';
// @ts-ignore
import ApexCharts from 'apexcharts';
import { MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
var JourgemachinedashboardComponent = /** @class */ (function () {
    function JourgemachinedashboardComponent(JourgemachineService, dialog, cdr) {
        this.JourgemachineService = JourgemachineService;
        this.dialog = dialog;
        this.cdr = cdr;
        this.deviceList = [];
        this.isTotalUtilization = false;
        this.status = '';
        this.operationalHour = 0;
        this.operationalMinute = 0;
        this.operationalSeconds = 0;
        this.statusArray = ['working', 'maintenance', 'quality', 'fault', 'setup', 'off'];
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.heading = [];
        this.isReport = false;
        this.isWorkingDuration = false;
        this.filter = {};
    }
    JourgemachinedashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.timeFilter = 'Today';
        this.workingtimeFilter = 'This Week';
        //this.getDaywiseDATA({"filter":"This Week"},"workingChart")
        this.getReport({ "filter": "Today" });
        this.filters('date', 'Today');
        this.getDeviceIDS();
        setInterval(function () {
            _this.getData();
        }, 10000);
        setTimeout(function () {
            _this.utilizationRate(null, "chart");
            _this.operationEfficiencyScore();
        }, 10);
        setTimeout(function () {
            _this.getDataFromDatabase();
        }, 100);
    };
    JourgemachinedashboardComponent.prototype.getDeviceData = function (device) {
        this.selectedDevice = device;
        this.getDataFromDatabase();
        //this.getDaywiseDATA(this.filter,"workingChart1");
        this.getReport(this.filter);
    };
    JourgemachinedashboardComponent.prototype.getDeviceIDS = function () {
        var _this = this;
        this.JourgemachineService.getDeviceIDS().subscribe(function (data) {
            if (data.status) {
                console.log(data.data);
                _this.deviceList = data.data;
                _this.selectedDevice = _this.deviceList[0].deviceid;
            }
        });
    };
    JourgemachinedashboardComponent.prototype.getDataFromDatabase = function () {
        var _this = this;
        console.log("selected device ", this.selectedDevice);
        this.JourgemachineService.getMachineData({ deviceid: this.selectedDevice }).subscribe(function (data) {
            if (data.code == 1) {
                delete data.data[0].id;
                _this.latestData = data.data[0];
                console.log("is this data", _this.latestData.deviceid.toUpperCase(), _this.selectedDevice);
                if (_this.latestData.deviceid.toUpperCase() == _this.selectedDevice.toUpperCase()) {
                    console.log("inside if");
                    _this.status = Object.entries(_this.latestData).slice(0, 8)
                        .filter(function (_a) {
                        var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
                        return value == 1;
                    })
                        .map(function (_a) {
                        var _b = tslib_1.__read(_a, 1), key = _b[0];
                        return key;
                    });
                }
                console.log("this.status", Object.entries(_this.latestData).slice(0, 7));
                // this.calculateOperationalTime(data.data[0]);
                // this.utilizationRate(data.data[0],"chart")
                _this.updateUtilizationRate(data.data[0]);
                _this.updateoperationalEfficiency(data.data[0]);
                _this.statusArray = _this.statusArray.filter(function (status) { return status !== _this.status[0]; });
                console.log("/////////////", _this.statusArray);
            }
        });
    };
    JourgemachinedashboardComponent.prototype.getData = function () {
        var _this = this;
        this.JourgemachineService.listenForUpdates().subscribe(function (data) {
            console.log(data);
            if (data.code == 1) {
                _this.latestData = data.data;
                console.log("what is inside", data.data);
                if (_this.latestData.device_id.toUpperCase() == _this.selectedDevice.toUpperCase()) {
                    _this.status = Object.entries(_this.latestData)
                        .slice(0, 7)
                        .filter(function (_a) {
                        var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
                        return value == 1;
                    })
                        .map(function (_a) {
                        var _b = tslib_1.__read(_a, 1), key = _b[0];
                        return key;
                    });
                }
                //this.calculateOperationalTime(data.data);
                _this.statusArray = ['working', 'maintenance', 'quality', 'fault', 'setup', 'off'];
                _this.statusArray = _this.statusArray.filter(function (status) { return status !== _this.status[0]; });
            }
        });
    };
    JourgemachinedashboardComponent.prototype.calculateOperationalTime = function (data) {
        var totalTime = Number(data.workingDuration) + Number(data.qualityDuration) + Number(data.setupDuration);
        this.operationalHour = Number(Math.floor(totalTime / 60)); // Extract hours
        this.operationalMinute = Number(totalTime % 60); // Extract remaining minutes
        this.operationalSeconds = Number(String(Math.round((totalTime % 1) * 60)).padStart(1, '0'));
        var durationSum = this.reportdata
            .filter(function (value) {
            return value.Machine_state == "working" ||
                value.Machine_state == "setup" ||
                value.Machine_state == "quality";
        })
            .reduce(function (sum, value) { return sum + Number(value.Duration || 0); }, 0);
        this.todaysoperationalHour = Number(Math.floor(durationSum / 60)); // Extract hours
        this.todaysoperationalMinute = Number(durationSum % 60); // Extract remaining minutes
        this.todaysoperationalSeconds = Number(String(Math.round((durationSum % 1) * 60)).padStart(2, '0'));
        if (this.reportdata[this.reportdata.length - 1].Machine_state == "working" || this.reportdata[this.reportdata.length - 1].Machine_state == "setup" || this.reportdata[this.reportdata.length - 1].Machine_state == "quality") {
            var latestTimeDiff = this.reportdata[this.reportdata.length - 1].diffTime;
            var latestoperationalHour = Number(Math.floor(latestTimeDiff / 60)); // Extract hours
            var latestoperationalMinute = Number(latestTimeDiff % 60); // Extract remaining minutes
            var latestoperationalSeconds = Number(String(Math.round((latestTimeDiff % 1) * 60)).padStart(2, '0'));
            this.operationalHour += latestoperationalHour;
            this.operationalMinute += latestoperationalMinute;
            this.todaysoperationalHour += latestoperationalHour;
            this.todaysoperationalMinute += latestoperationalMinute;
            if (this.todaysoperationalMinute >= 60) {
                this.todaysoperationalHour += Math.floor(this.todaysoperationalHour / 60); // Add overflow minutes as hours
                this.todaysoperationalMinute = this.todaysoperationalMinute % 60; // Keep remaining minutes
            }
            if (this.operationalMinute >= 60) {
                this.operationalHour += Math.floor(this.operationalMinute / 60); // Add overflow minutes as hours
                this.operationalMinute = this.operationalMinute % 60; // Keep remaining minutes
            }
            // Start the timer
            /*setInterval(() => {
              this.operationalSeconds += 1; // Increment seconds
              this.todaysoperationalSeconds += 1;
              // Handle overflow of seconds into minutes
              if (this.operationalSeconds === 60) {
                this.operationalSeconds = 0;
                this.operationalMinute += 1;
              }
              if (this.todaysoperationalSeconds === 60) {
                this.todaysoperationalSeconds = 0;
                this.todaysoperationalMinute += 1;
              }
            
              // Handle overflow of minutes into hours
              if (this.operationalMinute === 60) {
                this.operationalMinute = 0;
                this.operationalHour += 1;
              }
              if (this.todaysoperationalMinute === 60) {
                this.todaysoperationalMinute = 0;
                this.todaysoperationalHour += 1;
              }
            
            }, 1000);*/
        }
    };
    JourgemachinedashboardComponent.prototype.utilizationRate = function (data, domID) {
        var options = {
            series: [
                {
                    data: [
                        Number(0),
                        Number(0),
                        Number(0),
                        Number(),
                        Number(),
                        Number()
                    ]
                }
            ],
            chart: {
                type: 'bar',
                height: "90%",
                toolbar: {
                    show: false
                }
            },
            colors: ['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#FFFF00'],
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: ['#FFFFFF'],
                    fontSize: '1.5vh',
                },
                offsetX: 20,
                position: 'right',
                formatter: function (val) {
                    var hours = Number(Math.floor(val / 60));
                    var minute = Number(val % 60);
                    return hours + ":" + minute;
                }
            },
            xaxis: {
                categories: [
                    'Working',
                    'Off',
                    'Maintenance',
                    'Setup',
                    'Fault',
                    'Quality'
                ],
                labels: {
                    style: {
                        colors: '#FFFFFF',
                        fontSize: '1.5vh',
                    }
                }
            },
            yaxis: {
                title: {
                    text: 'Machine State',
                    style: {
                        fontSize: '1.5vh',
                        fontWeight: 'bold',
                        color: '#FFFFFF'
                    }
                },
                labels: {
                    style: {
                        colors: ['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#FFFF00'],
                        fontSize: '2vh',
                        fontWeight: 'bold'
                    }
                }
            },
            grid: {
                show: false
            },
            legend: {
                show: false
            },
            tooltip: {
                y: {
                    formatter: function (val, opts) {
                        var yLabels = [
                            'Working Duration',
                            'Off Duration',
                            'Maintenance Duration',
                            'Setup Duration',
                            'Fault Duration',
                            'Quality Duration'
                        ];
                        var seriesIndex = opts.seriesIndex; // Current series index
                        var dataPointIndex = opts.dataPointIndex; // Current data point index
                        return yLabels[dataPointIndex] + ": " + val + " Seconds";
                    }
                },
                theme: 'dark' // Sets a dark theme for better visibility
            },
            responsive: [
                {
                    breakpoint: 768,
                    options: {
                        chart: {
                            height: "100%"
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false
                            }
                        }
                    }
                }
            ]
        };
        this.utilizationchart = new ApexCharts(document.querySelector("#" + domID), options);
        this.utilizationchart.render();
    };
    JourgemachinedashboardComponent.prototype.updateUtilizationRate = function (newData) {
        if (this.utilizationchart) {
            var dataArray = [
                Number(newData.workingDuration || 0),
                Number(newData.offDuration || 0),
                Number(newData.maintenanceDuration || 0),
                Number(newData.setupDuration || 0),
                Number(newData.faultDuration || 0),
                Number(newData.qualityDuration || 0)
            ];
            this.utilizationchart.updateOptions({
                series: [{
                        data: dataArray
                    }]
            });
        }
    };
    JourgemachinedashboardComponent.prototype.workingChart = function (data, id) {
        var day = Array.from(new Set(data.map(function (data) { return data.date; })));
        var working = day.map(function (date) {
            var totalDuration = data
                .filter(function (entry) { return entry.date === date && entry.machinestate === "working"; })
                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
            return totalDuration;
        });
        var off = day.map(function (date) {
            var totalDuration = data
                .filter(function (entry) { return entry.date === date && entry.machinestate === "off"; })
                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
            return totalDuration;
        });
        var setup = day.map(function (date) {
            var totalDuration = data
                .filter(function (entry) { return entry.date === date && entry.machinestate === "setup"; })
                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
            return totalDuration;
        });
        var quality = day.map(function (date) {
            var totalDuration = data
                .filter(function (entry) { return entry.date === date && entry.machinestate === "quality"; })
                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
            return totalDuration;
        });
        var fault = day.map(function (date) {
            var totalDuration = data
                .filter(function (entry) { return entry.date === date && entry.machinestate === "fault"; })
                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
            return totalDuration;
        });
        var maintenance = day.map(function (date) {
            var totalDuration = data
                .filter(function (entry) { return entry.date === date && entry.machinestate === "maintenance"; })
                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
            return totalDuration;
        });
        var options = {
            series: [{
                    name: 'Working',
                    data: working
                }, {
                    name: 'Off',
                    data: off
                }, {
                    name: 'Maintenance',
                    data: maintenance
                }, {
                    name: 'Setup',
                    data: setup
                }, {
                    name: 'Fault',
                    data: fault
                }, {
                    name: 'Quality',
                    data: quality
                }],
            colors: ['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#ffdf80'],
            chart: {
                type: 'area',
                height: "100%",
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 1,
                    borderRadiusApplication: 'end',
                }
            },
            stroke: {
                curve: 'smooth',
                width: 0.9
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: day,
                title: {
                    text: 'Date Of Current Month',
                    style: {
                        fontSize: '1.5vh',
                        fontWeight: 'bold',
                        color: '#FFFFFF'
                    }
                },
                labels: {
                    style: {
                        colors: '#FFFFFF',
                        fontSize: '1.5vh',
                    }
                }
            },
            yaxis: {
                title: {
                    text: 'Time In Hours',
                    style: {
                        fontSize: '1.5vh',
                        fontWeight: 'bold',
                        color: '#FFFFFF'
                    }
                },
                labels: {
                    style: {
                        colors: '#FFFFFF',
                        fontSize: '1.5vh',
                    }
                }
            },
            legend: {
                labels: {
                    colors: '#FFFFFF',
                    style: {
                        fontSize: '1.5vh'
                    }
                },
                position: 'top',
            },
            tooltip: {
                y: {
                    formatter: function (val, opts) {
                        var seriesIndex = opts.seriesIndex; // Current series index
                        var dataPointIndex = opts.dataPointIndex; // Current data point index
                        return " " + val + " Minute";
                    }
                },
                theme: 'dark' // Sets a dark theme for better visibility
            },
            grid: {
                show: false
            }
        };
        var chart = new ApexCharts(document.querySelector("#" + id), options);
        chart.render();
    };
    JourgemachinedashboardComponent.prototype.popupworkingChart = function (data, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var day, working, off, setup, quality, fault, maintenance, graphType, options;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.workingchart) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.workingchart.destroy()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        day = Array.from(new Set(data.map(function (data) { return data.date; })));
                        working = day.map(function (date) {
                            var totalDuration = data
                                .filter(function (entry) { return entry.date === date && entry.machinestate === "working"; })
                                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
                            return totalDuration;
                        });
                        off = day.map(function (date) {
                            var totalDuration = data
                                .filter(function (entry) { return entry.date === date && entry.machinestate === "off"; })
                                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
                            return totalDuration;
                        });
                        setup = day.map(function (date) {
                            var totalDuration = data
                                .filter(function (entry) { return entry.date === date && entry.machinestate === "setup"; })
                                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
                            return totalDuration;
                        });
                        quality = day.map(function (date) {
                            var totalDuration = data
                                .filter(function (entry) { return entry.date === date && entry.machinestate === "quality"; })
                                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
                            return totalDuration;
                        });
                        fault = day.map(function (date) {
                            var totalDuration = data
                                .filter(function (entry) { return entry.date === date && entry.machinestate === "fault"; })
                                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
                            return totalDuration;
                        });
                        maintenance = day.map(function (date) {
                            var totalDuration = data
                                .filter(function (entry) { return entry.date === date && entry.machinestate === "maintenance"; })
                                .reduce(function (sum, entry) { return sum + Number(entry.duration); }, 0);
                            return totalDuration;
                        });
                        graphType = "area";
                        if (day.length < 2) {
                            graphType = "bar";
                        }
                        options = {
                            series: [{
                                    name: 'Working',
                                    data: working
                                }, {
                                    name: 'Off',
                                    data: off
                                }, {
                                    name: 'Maintenance',
                                    data: maintenance
                                }, {
                                    name: 'Setup',
                                    data: setup
                                }, {
                                    name: 'Fault',
                                    data: fault
                                }, {
                                    name: 'Quality',
                                    data: quality
                                }],
                            colors: ['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#ffdf80'],
                            chart: {
                                type: graphType,
                                height: "100%",
                                toolbar: {
                                    show: false
                                }
                            },
                            plotOptions: {
                                bar: {
                                    borderRadius: 1,
                                    borderRadiusApplication: 'end',
                                }
                            },
                            stroke: {
                                curve: 'smooth',
                                width: 0.9
                            },
                            dataLabels: {
                                enabled: false
                            },
                            xaxis: {
                                categories: day,
                                title: {
                                    text: 'Date Of Current Month',
                                    style: {
                                        fontSize: '1.5vh',
                                        fontWeight: 'bold',
                                    }
                                },
                                labels: {
                                    style: {
                                        fontSize: '1.5vh',
                                    }
                                }
                            },
                            yaxis: {
                                title: {
                                    text: 'Time In Hours',
                                    style: {
                                        fontSize: '1.5vh',
                                        fontWeight: 'bold',
                                    }
                                },
                                labels: {
                                    style: {
                                        fontSize: '1.5vh',
                                    }
                                }
                            },
                            legend: {
                                labels: {
                                    style: {
                                        fontSize: '1.5vh'
                                    }
                                },
                                position: 'top',
                            },
                            tooltip: {
                                y: {
                                    formatter: function (val, opts) {
                                        var seriesIndex = opts.seriesIndex; // Current series index
                                        var dataPointIndex = opts.dataPointIndex; // Current data point index
                                        return " " + val + " Minute";
                                    }
                                },
                                theme: 'dark' // Sets a dark theme for better visibility
                            },
                            grid: {
                                show: false
                            }
                        };
                        this.workingchart = new ApexCharts(document.querySelector("#" + id), options);
                        this.workingchart.render();
                        return [2 /*return*/];
                }
            });
        });
    };
    JourgemachinedashboardComponent.prototype.operationEfficiencyScore = function () {
        var options = {
            series: [0],
            chart: {
                height: '90%',
                padding: 0,
                type: 'radialBar',
                offsetY: 0
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '1.5vh',
                            color: '#964B00',
                            offsetY: '-5%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '2vh',
                            color: '#FFFFFF',
                            formatter: function (val) {
                                return val + " %";
                            }
                        }
                    }
                }
            },
            fill: {
                colors: ['#0B5345'],
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 0.1,
                },
            },
            stroke: {
                dashArray: 5
            },
            labels: ['Score %'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        this.operatoinalEfficiencychart = new ApexCharts(document.querySelector("#operatoinalEfficiency"), options);
        this.operatoinalEfficiencychart.render();
    };
    JourgemachinedashboardComponent.prototype.updateoperationalEfficiency = function (data) {
        var totalOperationalTime = Number(data.offDuration) + Number(data.qualityDuration) + Number(data.faultDuration) + Number(data.workingDuration) +
            Number(data.setupDuration) + Number(data.maintenanceDuration);
        this.utilizationsRate = Number(((Number(data.workingDuration) + Number(data.setupDuration)) / totalOperationalTime) * 100).toFixed(2);
        this.qualityRate = Number(Number(data.qualityDuration / totalOperationalTime) * 100).toFixed(2);
        this.utilization = (Number(this.utilizationsRate) + Number(this.qualityRate)).toFixed(2);
        this.downtimeRate = Number((Number(Number(data.offDuration) + Number(data.faultDuration) + Number(data.maintenanceDuration)) / totalOperationalTime) * 100).toFixed(2);
        this.operationalEfficiencyScore = Number(Number(this.utilizationsRate) + Number(this.qualityRate) - Number(this.downtimeRate)).toFixed(2);
        this.workingPercentage = ((Number(data.workingDuration) / totalOperationalTime) * 100).toFixed(2);
        this.setupPercentage = ((Number(data.setupDuration) / totalOperationalTime) * 100).toFixed(2);
        this.qualityPercentage = ((Number(data.qualityDuration) / totalOperationalTime) * 100).toFixed(2);
        this.maintenancePercentage = ((Number(data.maintenanceDuration) / totalOperationalTime) * 100).toFixed(2);
        this.offPercentage = ((Number(data.offDuration) / totalOperationalTime) * 100).toFixed(2);
        this.faultPercentage = ((Number(data.faultDuration) / totalOperationalTime) * 100).toFixed(2);
        if (this.operatoinalEfficiencychart) {
            this.operatoinalEfficiencychart.updateOptions({
                series: [Number(this.operationalEfficiencyScore)]
            });
        }
    };
    JourgemachinedashboardComponent.prototype.getDaywiseDATA = function (data, id) {
        var _this = this;
        data.deviceid = this.selectedDevice;
        this.JourgemachineService.getGeorgMachineWorkingReport(data).subscribe(function (data) {
            console.log("what is data", data);
            if (id == "workingChart") {
                _this.workingChartData = data.data;
                _this.workingChart(data.data, id);
            }
            else {
                _this.popupworkingChart(data.data, id);
            }
        });
    };
    JourgemachinedashboardComponent.prototype.getReport = function (data) {
        var _this = this;
        console.log("what is yesterdays data", data);
        data.device = this.selectedDevice;
        this.JourgemachineService.getGeorgMachineReport(data).subscribe(function (data) {
            console.log("report data", data);
            if (data.data.length > 0) {
                _this.heading = Object.keys(data.data[0]);
                _this.heading.pop();
                _this.reportdata = data.data;
                _this.dataSource = new MatTableDataSource(data.data);
                _this.dialogDataSource = new MatTableDataSource(data.data);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
            }
        });
    };
    JourgemachinedashboardComponent.prototype.openPopup = function (selected) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.dialogTemplate) return [3 /*break*/, 3];
                        dialogRef = this.dialog.open(this.dialogTemplate, {
                            width: '70%',
                            height: '70%',
                            panelClass: 'custom-dialog',
                        });
                        if (!(selected == "totalUtilization")) return [3 /*break*/, 2];
                        this.isWorkingDuration = false;
                        this.isReport = false;
                        _a = this;
                        return [4 /*yield*/, true];
                    case 1:
                        _a.isTotalUtilization = _b.sent();
                        dialogRef.afterOpened().subscribe(function () {
                            _this.utilizationRate(_this.latestData, "utilizationChart");
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        if (selected == "report") {
                            this.isTotalUtilization = false;
                            this.isWorkingDuration = false;
                            this.isReport = true;
                        }
                        else if (selected == "workingDuration") {
                            this.isReport = false;
                            this.isTotalUtilization = false;
                            this.isWorkingDuration = true;
                            dialogRef.afterOpened().subscribe(function () {
                                _this.popupworkingChart(_this.workingChartData, "workingChart1");
                            });
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    JourgemachinedashboardComponent.prototype.filters = function (type, param) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.timeFilter = param;
                        this.workingtimeFilter = param;
                        return [4 /*yield*/, this.formatDate(param)];
                    case 1:
                        filter = _a.sent();
                        //this.filter = this.filter + filter;
                        if (filter.filter === 'This Week' || filter.filter === 'This Month' || filter.filter === 'Last Month') {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            this.filter.startDate = filter.startDate;
                            this.filter.endDate = filter.endDate;
                            this.filter.filter = filter.filter;
                        }
                        else if (filter.filter === 'Today' || filter.filter === 'Yesterday') {
                            if (this.filter && this.filter.startDate && this.filter.endDate) {
                                delete this.filter.startDate;
                                delete this.filter.endDate;
                            }
                            this.filter.filter = filter.filter;
                            this.filter.date = filter.date;
                        }
                        else if (filter.filter === 'Custom') {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            if (filter.startDate && filter.endDate) {
                                this.filter.startDate = filter.startDate;
                                this.filter.endDate = filter.endDate;
                                this.filter.filter = filter.filter;
                            }
                        }
                        this.getReport(this.filter);
                        return [2 /*return*/];
                }
            });
        });
    };
    JourgemachinedashboardComponent.prototype.formatDate = function (param) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (param === 'Today') {
                var d = new Date(), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param });
                // return [year, month, day].join('-');
            }
            else if (param === 'Yesterday') {
                var date = new Date();
                date.setDate(date.getDate() - 1); // Subtract one day from the current date
                var year_1 = date.getFullYear();
                var month_1 = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
                var day_1 = ('0' + date.getDate()).slice(-2); // Add leading zero if needed
                var yesterday = year_1 + "-" + month_1 + "-" + day_1;
                resolve({ 'date': yesterday, 'filter': param });
                //return [year, month, day].join('-');
            }
            else if (param === 'Last Month') {
                resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
                // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
            }
            else if (param === 'This Month') {
                resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'This Week') {
                resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param });
                //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'Custom') {
                var dialogConfig = new MatDialogConfig();
                var dialogRef = _this.dialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: _this.customeSelectedDate }
                });
                dialogRef.afterClosed().subscribe(function (value) {
                    console.log("Value=======", value);
                    _this.customeSelectedDate = value;
                    resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param });
                });
            }
        });
    };
    return JourgemachinedashboardComponent;
}());
export { JourgemachinedashboardComponent };
